module.exports = __webpack_public_path__ + "media/luxury-2026/estate-daytime-facade-960-3c737d97.jpg";